import React from 'react';
export const InstructionConfiguration=(props,customerId)=>{
    if (customerId) {
        const Instructions = React.lazy(() => import(`./${customerId}/Instructions`));
        return <Instructions />;
      } else {
        return null;
      }
}